import {
  AppMinimumRequirementsForPasswordForm,
  emailAddressFormLogic,
  InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland,
  passwordForLoginFormLogic,
  recaptchaFormLogic,
} from "../../form";

import { GenericForm, GenericFormLogic } from "../../hooks";

export interface LoginForm extends GenericForm {
  email?: string;

  password?: string;
}

export interface InitialStateMinimumRequirements_LoginUsage {
  isCustomerLoggedIn?: boolean;
  login_form_recaptcha: InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland;
}

export interface AppMinimumRequirementsForLoginForm {
  initialState: InitialStateMinimumRequirements_LoginUsage;
}

export type LoginFormApp = AppMinimumRequirementsForPasswordForm &
  AppMinimumRequirementsForLoginForm;

export const LoginFormLogic: GenericFormLogic<LoginForm, LoginFormApp> = {
  email: emailAddressFormLogic({ required: true }),
  password: passwordForLoginFormLogic<LoginForm, LoginFormApp>({
    required: true,
  }),
  recaptcha: recaptchaFormLogic<LoginForm, LoginFormApp>({
    initialStateKey: "login_form_recaptcha",
  }),
} as const;

export const LoginFormInitialState = (): LoginForm => ({});
